import {useState} from "react";
import {createEditor, type Descendant, type Editor} from "slate";
import {withHistory} from "slate-history";
import {withReact} from "slate-react";

// Isolating this for testing purposes.
export const useSlateValue = () => useState([...initialValue]);

/**
 * The initial value of the Slate editor.
 */
export const initialValue: ReadonlyArray<Descendant> = [
    {
        type: "paragraph",
        children: [{text: ""}],
    },
];

/**
 * Create a Slate editor with appropriate plugins.
 */
export const createSlateInput = (): Editor =>
    withReferences(withMathQuill(withReact(withHistory(createEditor()))));

const withMathQuill = (editor: Editor): Editor => {
    const {isInline, isVoid} = editor;

    editor.isInline = (element) =>
        ["math-editor"].includes(element.type) || isInline(element);
    editor.isVoid = (element) =>
        ["math-editor"].includes(element.type) || isVoid(element);

    return editor;
};

const withReferences = (editor: Editor): Editor => {
    const {isInline, isVoid} = editor;

    editor.isInline = (element) =>
        ["reference"].includes(element.type) || isInline(element);
    editor.isVoid = (element) =>
        ["reference"].includes(element.type) || isVoid(element);

    return editor;
};
